var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VendorForm',{attrs:{"vendor":_vm.vendor,"formType":_vm.formType,"buttonLoading":_vm.buttonLoading},on:{"saveVendor":_vm.updateVendor}})}
var staticRenderFns = []

export { render, staticRenderFns }